import React, { useState } from 'react'
import { ProjectCardCN } from 'components/Card'
import { CARD_GRID_CLASS } from 'components/Card/cardGrid'
import ProjectActionSheet from './ProjectActionSheet'

const ProjectCards = ({ projects, userId }) => {
	const [sheetOpen, setSheetOpen] = useState(false)
	const [selectedProject, setSelectedProject] = useState(null)

	const handleThreeDotClick = project => {
		setSelectedProject(project)
		setSheetOpen(true)
	}

	return (
		<div>
			<div className={CARD_GRID_CLASS}>
				{projects.map((project, index) => (
					<div key={project._id || index}>
						<ProjectCardCN
							image={project.image}
							name={project.projectName}
							locationName={project.assetName}
							locationCityProv={`${project.city}, ${project.stateProvince}`}
							projectType={project.projectType}
							linkUrl={`/projects/${project._id}/tasks`}
							updatedAt={project.updatedAt}
							isOwner={project.owner === userId}
							onThreeDotClick={() => handleThreeDotClick(project)}
							ownerImage={project.ownerImage}
							ownerName={project.ownerName}
							ownerEmail={project.ownerEmail}
							ownerCompany={project.ownerCompany}
						/>
					</div>
				))}
			</div>

			<ProjectActionSheet
				project={selectedProject}
				open={sheetOpen}
				onClose={() => setSheetOpen(false)}
			/>
		</div>
	)
}

export default ProjectCards
